module.exports = __webpack_public_path__ + "static/d77e72753be51cb8cd5513c3099a43c5d80ea322b79074da22183f0e1066c454-8bff89c8a4a2a6de569ed6b68fbc72a2.png";